<h1>Are you sure?</h1>

<p>{{ message() || 'Are you sure you want to skip this task?' }}</p>

<oph-button color="brown" class="mb-10" [style]="{width: '200px'}" (buttonClick)="close.emit(false)">No</oph-button>
<oph-button color="gray" [style]="{width: '200px'}" [loading]="loading()" (buttonClick)="close.emit(true)"
  >Yes Skip</oph-button
>
